/* To change based on the label of dropdowns which is returned by API dropdowns/public/account_information/identification_type */

export const SOUTH_AFRICAN_ID = 10183
export const PASSPORT = 10184
export const TEMPORARY_PERMIT = 10185
